import { CheckmarkIcon } from "vega-icons";

import { ThemedButton } from "@vega-core/components/Buttons/ThemedButton";
import { isTruthy } from "@vega-core/utils/isTruthy";

type Props = {
  description?: string;
  firstAction?: VoidFunction;
  firstActionTitle?: string;
  secondAction?: VoidFunction;
  secondActionTitle?: string;
  title: string;
};

export function Success({
  description,
  firstAction,
  firstActionTitle,
  title,
}: Props) {
  return (
    <div className="flex w-96 flex-col items-center rounded-companyBorderRadius border-2 border-dark-gray-700 bg-dark-gray p-8 text-center">
      <div className="h-[130px] w-[130px] rounded-full bg-teal-700/[.3] p-[23px]">
        <div className="flex h-full w-full items-center justify-center rounded-full text-text/primary bg-background/primary">
          <CheckmarkIcon className="w-2/3 h-2/3" />
        </div>
      </div>
      <div className="mt-8 text-2xl font-bold">{title}</div>
      {isTruthy(description) ? (
        <div className="mt-2 text-sm font-normal text-light-gray-400">
          {description}
        </div>
      ) : null}
      <div className="mt-9 w-full">
        {firstAction ? (
          <ThemedButton
            dataTestId={`${firstActionTitle}-button`}
            fullWidth
            onClick={firstAction}
            variant="primary"
          >
            {firstActionTitle}
          </ThemedButton>
        ) : null}
      </div>
    </div>
  );
}
